import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import lookupService from "../services/LookupService";

export default function CustomerAddressSection({ value, onChange }) {
  const [iller, setIller] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [koyler, setKoyler] = useState([]);

  const [ilId, setIlId] = useState(value?.ilId ?? null);
  const [ilceId, setIlceId] = useState(value?.ilceId ?? null);
  const [koyId, setKoyId] = useState(value?.koyId ?? null);

  // İller
  useEffect(() => {
    lookupService.getIller().then(res => setIller(res.data));
  }, []);

  // İl değişince ilçeler
  useEffect(() => {
    if (!ilId) {
      setIlceler([]);
      setIlceId(null);
      setKoyler([]);
      setKoyId(null);
      return;
    }

    lookupService.getIlceler(ilId).then(res => setIlceler(res.data));
  }, [ilId]);

  // İlçe değişince köyler
  useEffect(() => {
    if (!ilceId) {
      setKoyler([]);
      setKoyId(null);
      return;
    }

    lookupService.getKoyler(ilceId).then(res => setKoyler(res.data));
  }, [ilceId]);

   

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-2 gap-y-3 p-fluid">
      {/* İL */}
      <div className=" ">
        <label className="block mb-2 font-semibold">İl</label>
        <Dropdown
          value={ilId}
          options={iller}
          optionLabel="name"
          optionValue="id"
          placeholder="İl seçiniz"
          className="w-full"
          filter
          onChange={(e) => {
            const newIlId = e.value;
            setIlId(newIlId);
            setIlceId(null);
            setKoyId(null);

            onChange?.({
                ilId: newIlId,
                ilceId: null,
                koyId: null,
            });
          }}
        />
      </div>

      {/* İLÇE */}
      <div className=" ">
        <label className="block mb-2 font-semibold">İlçe</label>
        <Dropdown
          value={ilceId}
          options={ilceler}
          optionLabel="name"
          optionValue="id"
          placeholder="İlçe seçiniz"
          className="w-full"
          filter
          disabled={!ilId}
          onChange={(e) => {
          const newIlceId = e.value;
          setIlceId(newIlceId);
          setKoyId(null);

          onChange?.({
            ilId,
            ilceId: newIlceId,
            koyId: null,
        });
        }}
        />
      </div>

      {/* KÖY */}
      <div className=" ">
        <label className="block mb-2 font-semibold">Köy</label>
        <Dropdown
          value={koyId}
          options={koyler}
          optionLabel="name"
          optionValue="id"
          placeholder="Köy (opsiyonel)"
          className="w-full"
          filter
          disabled={!ilceId}
          onChange={(e) => {
            const newKoyId = e.value;
            setKoyId(newKoyId);

            onChange?.({
                ilId,
                ilceId,
                koyId: newKoyId,
            });
            }}
        />
      </div>
    </div>
  );
}
